import { render, staticRenderFns } from "./Downlinks.vue?vue&type=template&id=20008181"
import script from "./Downlinks.vue?vue&type=script&lang=js"
export * from "./Downlinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports